import React, { useEffect } from 'react'
import Header from '../../../Layouts/Components/Header'
import AlertFilters from './AlertFilters'
import FollowingOnInternalAlerts from './FollowingOnInternalAlerts'
import { useFormik  } from 'formik'
import * as yup from "yup";
import {getFollowingAlerts , resetFollowingAlerts} from '../state/alertActions'
import {  useDispatch } from "react-redux";
import useSnackBar from "../../Hooks/useSnackBar";
import { endOfDay , startOfDay } from 'date-fns'
import format from 'date-fns/format'

const FollowingAlertsView = () => {
  const startDate = startOfDay(new Date())
  const endDate = endOfDay(new Date())
  const { error, snackbar ,success  } = useSnackBar();
  
  function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}
 
 const dispatch = useDispatch()

  const validationSchema = yup.object().shape({
    dateFrom: yup.string().nullable().required("Start Date is required"),
    dateTo: yup.string().nullable().required("End Date is required")
  })

 //aaaaa'm'
const formik = useFormik({
    initialValues: {
      dateFrom: startDate || null,
      dateTo: endDate || null,
    },
    validationSchema:validationSchema,
    onSubmit: values => {
      

      const mainValues = {
        from : format(new Date(values.dateFrom), "yyyy-MM-dd HH:mm"),
        to : format(new Date(values.dateTo) ,"yyyy-MM-dd HH:mm")
       }
       console.log(mainValues)
      dispatch(getFollowingAlerts(
        {
        pageNumber:1,
        pageSize:10,
        searchCriteria:{
          ...mainValues
        }  
      },
      error
      ))
      
    },
  });


  
  const data = {
    from : formik.values.dateFrom,
    to : formik.values.dateTo
   }
   useEffect(()=> {
    console.log("formik.values")
    
   dispatch(getFollowingAlerts(
    {
    pageNumber:1,
    pageSize:10,
    searchCriteria:{
      from:format(formik?.values?.dateFrom || startDate, "yyyy-MM-dd HH:mm"),
      to:format(formik?.values?.dateTo || endDate, "yyyy-MM-dd HH:mm"),
    }
   },
   error
   
   ))

   return () => {
    dispatch(resetFollowingAlerts())
   }
  },[error])   

  return (
<>
{snackbar}
<Header headLine="Following on Internal Alerts"/> 
<AlertFilters
formik={formik}
/>
<FollowingOnInternalAlerts error={error} success={success} data={data}/>

</>
  )
}

export default FollowingAlertsView